<template>
  <div class="tab-body">
    <div v-for="(item, index) in resultList" :key="index" class="criminal-body" :style="index == 0?'border-top: none':''">
      <div class="law-title">
          <h3 class="word-normal">{{item.basicLawName}}</h3>
          <h4 v-html="highlight(item.name, item.keyWords)"></h4>
          <p class="word-middle" v-html="highlight(item.content, item.keyWords)"></p>
      </div>
      <div class="criminal-trial" v-if="item.lawList && item.showDetail">
          <h5 class="word-big">刑事审判参考<span class="word-normal count">（{{item.count}}）</span></h5>
          <div class="criminal-trial-item" v-for="(col, idx) in item.lawList" :key="idx">
              <div class="criminal-name word-big" v-html="highlight(col.name, item.keyWords)"></div>
              <p class="word-normal criminal-little-name" v-if="col.subtitle">—— <span v-html="highlight(col.subtitle, item.keyWords)"></span></p>
              <div class="content-item word-normal" v-if="col.keyWord">
                  <span class="cur-key">【关键字】</span>
                  <span class="tag-status" style="margin-right:10px;" v-for="(val,i) in col.keyWord.split(',')" :key="i">{{val}}</span>
              </div>
              <div class="content-item word-normal" v-if="col.pdMan">
                  <span class="cur-key">【裁判要点】</span>
                  <span v-if="col.pdManShow == false"  v-html="highlight(col.pdMan,item.keyWords)"></span>
                  <span v-if="col.pdManShow" v-html="highlight(sliceStr(col.pdMan),item.keyWords)"></span>
                  <span v-if="col.pdMan.length> 120">
                  <span class="content-btn" @click="col.pdManShow = false" v-if="col.pdManShow">
                    <span><i class="el-icon-arrow-down" style="color:rgba(22,90,198,1)"></i></span>
                  </span>
                  <span class="content-btn" @click="col.pdManShow = true" v-if="col.pdManShow == false">
                    收起
                    <span><i class="el-icon-arrow-up" style="color:rgba(22,90,198,1)"></i></span>
                  </span>
                  </span> 
              </div>
              <div class="content-item word-normal">
                  <span class="cur-key">【详情】</span>
                  <span v-if="col.contentShow == false"  v-html="(highlight(col.content,item.keyWords)).replace(/\n/g,'<br>')"></span>
                  <span v-if="col.contentShow"  v-html="highlight(sliceStr(col.content),item.keyWords)"></span>
                  <span v-if="col.content.length> 120">
                    <span class="content-btn" @click="col.contentShow = false" v-if="col.contentShow">展开全文
                      <span><i class="el-icon-arrow-down" style="color:rgba(22,90,198,1)"></i></span>
                    </span>
                    <span class="content-btn" @click="col.contentShow = true" v-if="col.contentShow == false">收起
                      <span><i class="el-icon-arrow-up" style="color:rgba(22,90,198,1)"></i></span>
                    </span>
                  </span>
              </div>
              <div class="content-item word-normal" v-if="col.source || col.caseNos">
                  <a class="source">
                    <a class="cur-key">【来源】</a>
                    <span style="color:rgb(79, 94, 123)" v-show="col.source">
                      <span v-if="col.years">
                        <span v-if="col.years && col.years < 2015">{{col.source}}{{col.years}}年第{{col.whichEpisode}}集（总第{{col.totalEpisode}}集），第{{col.whichNumber}}号</span>
                        <span v-else-if="col.years && col.years>2015">{{col.source}}{{col.years}}年总第{{col.totalEpisode}}集，第{{col.whichNumber}}号</span>
                      </span>
                      <span v-show="col.caseNos">|</span> 
                    </span>
                    <span v-show="col.caseNos"><span v-for="(val,idx) in col.caseNos" :key="idx" @click.stop="caseDetail(val.id)">{{val.caseNo}}</span></span>
                  </a> 
              </div>
          </div>
      </div>

      <div class="criminal-trial" v-else>
        <h5 class="word-big" style="height:30px; border-bottom:1px solid #B1CFE7">刑事审判参考<span class="word-normal count">（0）</span></h5>
        <div class="criminal-no-data">
          <div style="text-align:center">
            <div class="img">
              <img src="../../assets/状态图标/criminal-no-content.png" alt="">
            </div>
            <p class="word-normal">暂无内容</p>
          </div>
        </div>
      </div>
    </div>  

    <div class="load-more" v-if="currentTotal<total">
      <div v-if="loading">
        <i style="color:@mainColor;font-size: 20px" class="el-icon-loading"></i>
        <span class="word-normal word-color1">页面加载中，请稍后…</span>
      </div>
      <div @click="loadMore" style="color:@mainColor" class="word-normal" v-else>查看更多</div>
    </div>

    <div v-if="resultList.length == 0 && isload">
      <div class="result-no-data" v-if="resultList.length == 0 ">
        <img src="../../assets/状态图标/no_result.png" />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {highlight,sliceStr} from '../../filter'
export default {
  data () {
    return {
       resultList:[],
       activeName: '1',
       searchKey: "",
       currentPage: 1,
       totalPage: "",
       loading: false,
       total: "",
       currentTotal: 0,
       isload: false
    };
  },
  props:{
    param:{
      type: String,
      default:""
    },
    clId:{
      type: String,
      default:""
    },
    selected:{
      type: Boolean,
      default: false
    }
  },

  watch:{
    // $route:function(val){
    //   if(val){
    //     this.fetchData()
    //   }
    // },
    // param:function(val){
    //   if(val){
    //     this.fetchData()
    //   }
    // },
    selected:function(val){
      if(val && !this.isload){
        this.fetchData(true)
      }
    }
  },

  mounted(){
    if(this.selected){
       this.fetchData(true)
    }
  },

  components: {},

  methods: {
    highlight:highlight,
    sliceStr:sliceStr,
    loadMore(){
      this.currentPage ++;
      this.fetchData(false);
    },
    fetchData(load){
      this.searchKey = this.param;
      let param = {
        currentPage: this.currentPage,
        size: 15,
        param: this.searchKey,
        clId: this.clId
      }
      if(!load){
        this.loading = true
      }
      this.httpGet('law/criminal/search',param,load).then((data)=>{
        this.loading = false;
        this.isload = true;
        if(data && data.statusCode == 1){
          this.total = data.data.total;
          if(this.total == 0){
            this.resultList = data.data.data;
          }else{
            data.data.data.forEach(v => {
              if(v.lawList){
                this.currentTotal += v.lawList.length;
                v.lawList.forEach((val)=>{
                  this.$set(val,'pdManShow',true)
                  this.$set(val,'contentShow',true)
                })
                var find = _.find(this.resultList, {id:v.id});
                if(!find){
                  this.resultList.push(v);
                }
                else{
                  v.lawList.forEach(a=>{
                    var found = _.find(find.lawList, {id:a.id});
                    if(!found){
                      find.lawList.push(a);
                    }
                  }) 
                }
              } 
            });
          }
          
        }
      });
    }
  }
}

</script>
<style scoped lang="less">
.tab-body h4{
  font-size: 24px;
  color: @wordColor1;
  margin: 14px 0;
}
.law-title{
  padding-top: 20px;
}
.law-title h3{
  height: 30px;
  display: inline-block;
  line-height: 30px;
  text-align: center;
  background:rgba(215,233,255,1);
  border-radius: 2px;
  color: #4A90E2;
  padding: 0 8px;
}

.law-title h4{
  font-weight: bold;
  line-height: 30px;
}
.tab-body .law-title p{
  color: @wordColor1;
  line-height: 20px;
}
.criminal-trial{
  width: 100%;
  margin-top: 30px;
  padding-bottom: 30px;
}

.tag-status{
  height: 20px;
  background: #F5F5F5;
  border-radius: 2px;
  display: inline-block;
  font-size: 12px;
  color: #999999;
  padding: 0 6px;
  line-height: 20px;
}
.content-btn{
  position: absolute;
  right: 0;
  bottom: -14px;
  color:#4A90E2;
  font-size: 14px;
  cursor: pointer;
}
.content-btn .icon-smaller{
  margin-bottom: 4px;
  margin-left: 5px;
}
.criminal-trial h5{
  color: @wordColor1;
  font-weight: bold;
}

.criminal-trial .count{
  color: #879BBA;
  font-weight: normal;
}

.criminal-trial-item{
  background:rgba(255,255,255,1);
  border:1px solid @lineColor;
  margin-top: 10px;
  padding: 15px;
}
.criminal-name{
  color: @wordColor1;
  line-height: 25px;
  font-weight: bold;
}

.criminal-little-name{
  color: @wordColor1;
  margin-top: 10px;
}

.content-item{
  color: @wordColor1;
  line-height: 24px;
  margin-top: 20px;
  position: relative;
}

.content-item .cur-key{
  color: @mainColor;
  margin-left: -10px;
}

.load-more{
  width: 100%;
  height: 45px;
  line-height: 45px;
  text-align: center;
  color: @wordColor1;
  background:rgba(255,255,255,1);
  border:1px solid @lineColor;
  margin-top: 10px;
  margin-bottom: 30px;
  cursor: pointer;
}

.criminal-body{
  background: #fff;
  padding: 0 15px;
  margin-bottom: 10px;
  border: 1px solid @lineColor;
}

.result-no-data{
  position: absolute;
  width: 100%;
  background: #fff;
  height: 100%;
  text-align: center;
  top: -10px;
  box-sizing: border-box;
  border: 1px solid @lineColor;
  border-top: none;
}

.result-no-data img{
  width: 280px;
  display: block;
  margin: 0 auto;
  margin-top: 165px;
}

.criminal-no-data p{
  color: @wordColor1;
}

.criminal-no-data .img{
   width: 100px;
   margin: 17px auto 6px auto;
}

.criminal-no-data .img img{
  width: 100%;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/criminal/index.vue